import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAUVAjGVQhgwCCclqc997qSh_XPwUleRSw',
    // libraries: ['geometry']
    libraries: 'places'
  }
});
